import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { environment } from "../../../../environments/environment";
import { IEmployeeContractRepository } from "./IEmployeeContractRepository";
import { EmployeeContract } from "../../../models/HR/EmployeeContract/employee-contract.model";

@Injectable()
export class EmployeeContractRepository extends GenericRepository<EmployeeContract> implements IEmployeeContractRepository {
 
  url: string = environment.urlAddress;
  constructor(protected _http: HttpClient) {
      super(_http, 'api/EmployeeContract', environment.urlAddress);
    }   
    GetAll(currentPage: number, recordsPerPage: number, filterText: string,callFromDirectory:boolean=false): Observable<any> {      
        return this.Get('/SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + callFromDirectory+'/'+filterText).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(item: EmployeeContract): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('/NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(code: string): Observable<ResponseModel> {
        return this.GetById('/GetRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadEmployeeLeavesAndDependent(employeeCode: string, employeeContractCode: string): Observable<ResponseModel> {
        return this.GetById('/SelectEmployeeLeavesAndDependent/' + employeeCode + '/' + employeeContractCode).pipe(map(this.extractData), catchError(this.handleError));
    }
    EmployeeContractWithEmployeeCode(employeeCode: string): Observable<ResponseModel> {
        return this.GetById('/SelectEmployeeContractByEmployeeCode/' + employeeCode).pipe(map(this.extractData), catchError(this.handleError));
    }
}